import { Container, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const PageIntro = ({bg, subheading, heading, desc}) => {
  return (
    <Container
        sx={{
          backgroundImage:
            `url(${bg})`, // Add image background
          backgroundPosition: "center",
          backgroundSize: "cover",
          maxWidth: "100% !important",
          height: { xs: "380px", sm: "450px", md: "480px" }, // Responsive height
          display: "flex",
          overflowX: "hidden",
          margin: "0 !important",
          alignItems: "center", // Center content vertically
          justifyContent: "center", // Center content horizontally
          padding: { xs: "20px", sm: "40px", md: "90px" }, // Responsive padding
          overflow: "hidden",
        }}
      >
        <section
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start", // Left align content
            width: "100%",
            maxWidth: { xs: "90%", sm: "80%", md: "70%" }, // Responsive width
          }}
        >
          {/* Heading */}
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "18px", sm: "22px", md: "24px" }, // Responsive font size
              color: "#FFFFFF",
              lineHeight: "120%",
              letterSpacing: "2%",
              paddingBottom: { xs: "10px", sm: "15px", md: "20px" },
            }}
          >
            {subheading}
          </Typography>

          {/* Subheading */}
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "28px", sm: "48px", md: "60px" }, // Responsive font size
              color: "#F005A2",
              lineHeight: "120%",
              letterSpacing: "2%",
              paddingBottom: { xs: "10px", sm: "15px", md: "20px" },
            }}
          >
            {heading}
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "16px", sm: "20px", md: "24px" }, // Responsive font size
              color: "#FFFFFF",
              lineHeight: "140%",
              letterSpacing: "2%",
              paddingBottom: { xs: "15px", sm: "20px", md: "25px" },
            }}
          >
            {desc}
          </Typography>

          {/* Button */}
          <Link
            to="/clientForm"
            style={{
              display: "flex",
              width: "fit-content",
              padding: "12px 24px", // Responsive padding
              backgroundColor: "#F005A2",
              borderRadius: "45px",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <div
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: { xs: "14px", sm: "16px", md: "18px" }, // Responsive font size
                letterSpacing: "0.08em",
                fontWeight: "700",
              }}
            >
              Talk to Us
            </div>
            <div
              className="submitBtn__Arrow"
              style={{
                width: { xs: "28px", sm: "32px" }, // Responsive size
                height: { xs: "28px", sm: "32px" }, // Responsive size
                backgroundColor: "#FFFFFF",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "10px",
              }}
            >
              <ArrowForwardIcon
                style={{
                  fontSize: { xs: "18px", sm: "24px" }, // Responsive size
                }}
              />
            </div>
          </Link>
        </section>
      </Container>

  )
}

export default PageIntro